module.exports = __webpack_public_path__ + "static/media/taizo-yamamoto-desk-tall.7f3c6e42.jpeg";